import { ThemeEvents, CartAddEvent, CartUpdateEvent } from '@theme/events';

let pending = false;
let busy = false;

function sectionIds() {
  return [...new Set([...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean))].slice(0, 5);
}

async function addEcrin(variantId) {
  if (busy) return false;
  busy = true;
  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds(), sections_url: window.location.pathname }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'error');
    let cart = {};
    try {
      const r = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (r.ok) cart = await r.json();
    } catch {}
    document.dispatchEvent(new CartAddEvent(cart, 'latea-ecrin', { source: 'latea-ecrin', variantId: String(variantId), itemCount: cart.item_count, sections: result.sections }));
    for (const check of document.querySelectorAll('[data-latea-ecrin-check]')) {
      check.checked = true;
      check.disabled = true;
      const status = check.closest('.latea-ecrin')?.querySelector('[data-latea-ecrin-status]');
      if (status) status.textContent = 'Ajouté à votre panier';
    }
    return true;
  } catch {
    return false;
  } finally {
    busy = false;
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
  const check = document.querySelector('[data-latea-ecrin-check]');
  pending = Boolean(check && check.checked && !check.disabled);
}, true);

async function capEcrin() {
  try {
    const root = window.Shopify?.routes?.root ?? '/';
    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const item = (cart.items || []).find((i) => i.product_type === 'Packaging' && i.quantity > 1);
    if (!item) return;
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 1, sections: sectionIds(), sections_url: window.location.pathname }),
    });
    if (!response.ok) return;
    const result = await response.json();
    document.dispatchEvent(new CartUpdateEvent(result, 'latea-ecrin', { source: 'latea-ecrin', itemCount: result.item_count, sections: result.sections }));
  } catch {}
}

capEcrin();

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const data = event.detail?.data ?? {};
  if (data.source !== 'latea-ecrin' && !data.didError) capEcrin();
  if (!pending || data.source === 'latea-ecrin' || data.didError) return;
  pending = false;
  const check = document.querySelector('[data-latea-ecrin-check]');
  if (check && check.checked && !check.disabled) addEcrin(check.dataset.variantId);
});

document.addEventListener(ThemeEvents.cartError, () => { pending = false; });

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-latea-ecrin-add]') : null;
  if (!button) return;
  event.preventDefault();
  button.disabled = true;
  const ok = await addEcrin(button.dataset.variantId);
  if (!ok && button.isConnected) {
    button.disabled = false;
    button.textContent = 'Réessayer';
  }
});
